export default __webpack_public_path__ + "static/media/mic.d1225595.svg";